import { FC } from "react";
import { useAtom } from "jotai";
import {
  Alert,
  AlertDescription,
  Surface,
  Text,
  ToggleSwitch,
} from "@zapier/design-system";
import { isViewOnlyModeAtom } from "@zapier/canvas-state";

import styles from "./DevTools.module.css";

export const StatesTabContent: FC = () => {
  const [isViewOnlyMode, setIsViewOnlyMode] = useAtom(isViewOnlyModeAtom);
  return (
    <div className={styles.devtoolsSectionWrapper}>
      <Alert title="" status="info" variant="compact">
        <AlertDescription>
          <Text type="MinimalPrint3">
            This section allows you to toggle different Canvas states.
          </Text>
        </AlertDescription>
      </Alert>
      <Surface backgroundColor="PrimeWhite" borderColor="GrayWarm5">
        <div className={styles.devtoolsInner}>
          <div className={styles.flexRow}>
            <Text type="Body3">View-Only Mode</Text>
            <div className={styles.toggleWrapper}>
              <ToggleSwitch
                checked={isViewOnlyMode}
                onChange={() => {
                  setIsViewOnlyMode((prev) => !prev);
                }}
              />
            </div>
          </div>
        </div>
      </Surface>
    </div>
  );
};
